import { TextWithImageBlock } from "../../../types";
import { RichText } from "@/features/sanity";
import { CTAButton } from "../../ui/CTAButton";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

interface TextWithImageProps {
  block: TextWithImageBlock;
}

export default function TextWithImage({ block }: TextWithImageProps) {
  const navigate = useNavigate();
  const isImageRight = block.orientation === "right";

  return (
    <div className="overflow-hidden bg-prime-50 mt-8 md:mt-16">
      <div className="">
        <div
          className={cn(
            "flex md:flex-row flex-col gap-12 lg:items-start lg:justify-end max-w-[95rem] mx-auto",
            isImageRight ? "md:flex-row" : "md:flex-row-reverse"
          )}
        >
          {/* Text Content */}
          <div className="flex-1 p-6 md:p-10">
            <h2 className="text-3xl md:text-4xl font-semiold font-serif text-dark-200 mb-6">
              {block.title}
            </h2>
            <div className="prose prose-lg text-gray-600">
              <RichText value={block.text} />
            </div>

            {block.cta && (
              <div className="mt-8">
                <CTAButton
                  onClick={() => {
                    if (block.cta?.link) {
                      if (block.cta.link.startsWith("http")) {
                        window.location.href = block.cta.link;
                      } else {
                        navigate(block.cta.link);
                      }
                    }
                  }}
                  variant={
                    block.cta.style === "outline"
                      ? "outline"
                      : block.cta.style === "secondary"
                      ? "secondary"
                      : "primary"
                  }
                >
                  {block.cta.text || "Mehr erfahren"}
                </CTAButton>
              </div>
            )}
          </div>

          {/* Image */}
          <div className="flex-1 w-full p- md:p-10">
            {block.image?.asset?.url && (
              <div className="relative">
                <img
                  src={block.image.asset.url}
                  alt={block.image.alt || block.title}
                  className="w-full h-full "
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
